module.exports = __webpack_public_path__ + "img/1-4.a934429e.png";